module.exports = __webpack_public_path__ + "img/amex.c7a02b51.svg";